import { IKioskMessage, IKIOSKModel } from '../../../../models/kioskModel';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { mobileVerification_Request } from '../../../../store/actions';
import { Ilanguages } from '../../../../models/utilitiesModel';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const DobPage: React.FC<any> = (props) => {
    const { t } = useTranslation("translations");
    const dispatch = useDispatch();
    const monthRef: any = useRef();
    const yearRef: any = useRef();
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const mobileNo: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.mobileNumber);
    let months = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, "0"));
    const years = Array.from({ length: 126 }, (_, i) => new Date().getFullYear() - 125 + i);
    const [selectedMonth, setSelectedMonth] = useState(months[months?.length - 2]);
    const [selectedYear, setSelectedYear] = useState(years[years?.length - 2]);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);

    console.log("DobForm===>", { selectedMonth, selectedYear, years, len: months?.length - 1 });
    
    const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const itemHeight = 80; // Height of each date item
    const handleScrollEnd = (ref: React.RefObject<HTMLDivElement>, type: "month" | "year") => {
        if (!ref.current) return;
        const scrollTop = ref.current.scrollTop;
        const index = Math.round(scrollTop / itemHeight);
        const targetScroll = index * itemHeight;
        ref.current.scrollTo({
            top: targetScroll,
            behavior: "smooth",
        });
        if (type === "year") setSelectedYear(years[index]);
        if (type === "month") setSelectedMonth(months[index]);
    };
    const handleScroll = (ref: React.RefObject<HTMLDivElement>, type: "month" | "year") => {
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        // Delay alignment until user finishes scrolling (debouncing)
        debounceTimer.current = setTimeout(() => handleScrollEnd(ref, type), 100);
    };

    if (selectedYear === new Date().getFullYear()) {
        months = months?.slice(0, (new Date().getMonth() + 1))
    }
    const initializeScrollPosition = () => {
        if (monthRef.current && yearRef.current) {
            const monthInitialIndex = months.indexOf(selectedMonth);
            const yearInitialIndex = years.indexOf(selectedYear);
            monthRef.current.scrollTo({
                top: monthInitialIndex * itemHeight,
                behavior: "auto",
            });
            yearRef.current.scrollTo({
                top: yearInitialIndex * itemHeight,
                behavior: "auto",
            });
        }
    };
    useEffect(() => {
        initializeScrollPosition();
    });

    let requestObject = {
        mobileNumber: mobileNo,
        dob: `${selectedYear}-${selectedMonth}`
    }
    const handleSubmit = () => {
        dispatch(mobileVerification_Request(requestObject))
    }
    return (
        <div className="Kiosk_datepicker">
            <h3 className="mt-5">{(getLabelConfigMsg(kioskConfigMsgs, language, "dob") || t("kiosktranslation.dob" + language))}</h3>
            <div className="date-picker-container">
                <div className="date-columns">
                    {/* Months Column */}
                    <div className="date-viewport">
                        <div
                            className="scroll-content months"
                            ref={monthRef}
                            onScroll={() => handleScroll(monthRef, "month")}
                        >
                            <div className="date-item"></div>
                            {months?.map((month, idx) => (
                                <div
                                    key={idx}
                                    className={`date-item ${month === selectedMonth ? "selected" : ""}`}
                                    style={{ height: itemHeight }}
                                >
                                    {month}
                                </div>
                            ))}
                            <div className="date-item"></div>
                        </div>
                    </div>
                    {/* Years Column */}
                    <div className="date-viewport">
                        <div
                            className="scroll-content years"
                            ref={yearRef}
                            onScroll={() => handleScroll(yearRef, "year")}
                        >
                            <div className="date-item"></div>
                            {years.map((year, idx) => (
                                <div
                                    key={idx}
                                    className={`date-item ${year === selectedYear ? "selected" : ""}`}
                                    style={{ height: itemHeight }}
                                >
                                    {year}
                                </div>
                            ))}
                            <div className="date-item"></div>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" className='kiosk_generate_btn w-100 mt-4' onClick={handleSubmit}>{(getLabelConfigMsg(kioskConfigMsgs, language, "Submit") || t("kiosktranslation.Submit" + language))}</button>
        </div>
    )
}
export default React.memo(DobPage)